import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  recordExportLineItemName: {
    description: 'recordExport.exportLineItemName',
    defaultMessage: 'Item Name',
    id: 'vBLVu3',
  },
  recordExportLineItemQuantity: {
    description: 'recordExport.exportLineItemQuantity',
    defaultMessage: 'Item Quantity',
    id: '90uQxI',
  },
  recordExportLineItemSku: {
    description: 'recordExport.exportLineItemSku',
    defaultMessage: 'Item SKU',
    id: '0/epLn',
  },
  orderExportNotifHeader: {
    description: 'orderExport.orderExportNotifHeader',
    defaultMessage: 'Exporting Orders',
    id: 'ttssbS',
  },
  orderExportNotifBody: {
    description: 'orderExport.orderExportNotifBody',
    defaultMessage: 'Your Order Export is being generated.',
    id: 'wPulPh',
  },
  orderExportNotifDoneHeader: {
    description: 'orderExport.orderExportNotifDoneHeader',
    defaultMessage: 'Order Export Ready for Download',
    id: 'S1xQ7a',
  },
  orderExportNotifDoneBody: {
    description: 'orderExport.orderExportNotifDoneBody',
    defaultMessage: 'Your order export is ready. A download should have started automatically.',
    id: 'xzSTKn',
  },
  orderExportErrorHeader: {
    description: 'orderExport.orderExportErrorHeader',
    defaultMessage: 'Order Export Error',
    id: 'j9Jh+4',
  },
  orderExportErrorBody: {
    description: 'orderExport.orderExportErrorBody',
    defaultMessage: 'An error occurred while attempting to export. Please try again.',
    id: 'y/e+L6',
  },
  shipmentExportNotifHeader: {
    description: 'shipmentExport.shipmentExportNotifHeader',
    defaultMessage: 'Exporting Shipments',
    id: 'YTtdHd',
  },
  shipmentExportNotifBody: {
    description: 'shipmentExport.shipmentExportNotifBody',
    defaultMessage: 'Your Shipment Export is being generated.',
    id: 'WRSI0c',
  },
  shipmentExportNotifDoneHeader: {
    description: 'shipmentExport.shipmentExportNotifDoneHeader',
    defaultMessage: 'Shipment Export Ready for Download',
    id: 'bRZxsg',
  },
  shipmentExportNotifDoneBody: {
    description: 'shipmentExport.shipmentExportNotifDoneBody',
    defaultMessage: 'Your shipment export is ready. A download should have started automatically.',
    id: 'NsiVGs',
  },
  shipmentExportErrorHeader: {
    description: 'shipmentExport.shipmentExportErrorHeader',
    defaultMessage: 'Shipment Export Error',
    id: 'cVE6Ae',
  },
  shipmentExportErrorBody: {
    description: 'shipmentExport.shipmentExportErrorBody',
    defaultMessage: 'An error occurred while attempting to export. Please try again.',
    id: 'KgRLOd',
  },
});
